module.exports = __webpack_public_path__ + "img/user-placeholder.8cf04f14.png";